import React, { useEffect, useState } from 'react';

import { Box, Grid, TextField, Typography } from '@material-ui/core';

import FloatingButton from '../../../../components/FloatingButton';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';

const AssistanceComments = () => {
  const { nextStep, assistance_body, updateAssistanceBody } =
    useAssistanceDataContext();
  const [comment, setComment] = useState('');
  const { user } = useAuthDataContext();

  const CallNextStep = () => {
    dataLayerPush('asistencia_informaciónImportante', user?.id);
    nextStep();
  };

  useEffect(() => {
    if (assistance_body.additional_comments) {
      setComment(assistance_body.additional_comments);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const updateAssistanceComments = (event: any) => {
    setComment(event.target.value);
    updateAssistanceBody({
      additional_comments: event.target.value,
    });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6">
            ¿Querés sumar información que consideres importante?
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={8}>
        <Box my={2}>
          <TextField
            size="small"
            multiline
            rows={5}
            name="origin"
            fullWidth={true}
            id="origin"
            placeholder="Dejanos tus comentarios"
            variant="outlined"
            onChange={updateAssistanceComments}
            value={comment}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FloatingButton onClick={() => CallNextStep()}>
          Continuar
        </FloatingButton>
      </Grid>
    </Grid>
  );
};

export default AssistanceComments;
